import { Box, Dialog, List, ListItem, ListItemButton, ListItemText, Paper, Typography } from '@mui/material';
import React, { useState } from 'react'
import WEBGLPlayer from './WEBGLPlayer';
import { useSnackbar } from "notistack";
import { useEffect } from 'react';
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import { blobSAS, handleCacheControl } from '../Helper/BlobHelper';
import moment from 'moment';

var token = getCookie("bb_metaverse_token");

const VersionLists = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState([]);
    const [url, setUrl] = useState({});
    const [webglDialog, setWebglDialog] = useState(false);
    const [assetData] = useState({});

    const handleWebglDialog = () => {
        setWebglDialog(false)
    }

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getData() {
        Service.get(`/api/asset/version/get_version_by_project/?project_asset=${props.data.id} `, {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            setData(res.data)

        }).catch(error => {
            console.log(error);
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
        })
    }
    const setSource = async (data) => {
        let asset = data?.asset_source?.split(",");
        const obj = {};
        let sasToken = await blobSAS({ token_type: 'read_only', container_name: 'project-executables' });
        let sasWebGLToken = await blobSAS({ token_type: 'read_only', container_name: 'webgl-template' });
        if (asset?.length > 0) {
            for (let index = 0; index < asset.length; index++) {
                const element = asset[index];
                if (element.includes('webgl-template')) {
                    if (element.includes(".data.unityweb") || element.includes(".data.br") || element.includes(".data")) {
                        obj.dataUrl = sasWebGLToken.fd_account_url + '/' + element + "?" + sasWebGLToken.read_only?.['webgl-template'].sas_token;
                    } else if (element.includes(".wasm.unityweb") || element.includes(".wasm.br") || element.includes(".wasm")) {
                        obj.codeUrl = sasWebGLToken.fd_account_url + '/' + element + "?" + sasWebGLToken.read_only?.['webgl-template'].sas_token;
                    } else if (element.includes(".loader")) {
                        obj.loaderUrl = sasWebGLToken.fd_account_url + '/' + element + "?" + sasWebGLToken.read_only?.['webgl-template'].sas_token;
                    } else if (element.includes(".framework.js.unityweb") || element.includes(".framework.js.br") || element.includes(".framework.js")) {
                        obj.frameworkUrl = sasWebGLToken.fd_account_url + '/' + element + "?" + sasWebGLToken.read_only?.['webgl-template'].sas_token;
                    }
                } else {
                    if (element.includes(".data.unityweb") || element.includes(".data.br") || element.includes(".data")) {
                        obj.dataUrl = sasToken.fd_account_url + '/' + element + "?" + sasToken.read_only?.['project-executables'].sas_token;
                    } else if (element.includes(".wasm.unityweb") || element.includes(".wasm.br") || element.includes(".wasm")) {
                        obj.codeUrl = sasToken.fd_account_url + '/' + element + "?" + sasToken.read_only?.['project-executables'].sas_token;
                    } else if (element.includes(".loader")) {
                        obj.loaderUrl = sasToken.fd_account_url + '/' + element + "?" + sasToken.read_only?.['project-executables'].sas_token;
                    } else if (element.includes(".framework.js.unityweb") || element.includes(".framework.js.br") || element.includes(".framework.js")) {
                        obj.frameworkUrl = sasToken.fd_account_url + '/' + element + "?" + sasToken.read_only?.['project-executables'].sas_token;
                    }
                }
            }
        }
        obj.cacheControl = handleCacheControl;
        let objkey = Object.keys(obj);
        if (objkey.length === 5) {
            setUrl(obj);
            assetData.version = data.version;
            assetData.versionCode = data.version_code;
            assetData.asset_id = data.project_asset;
            assetData.version_id = data.id;
            assetData.asset_key = data.asset_key;
            setWebglDialog(true);
        } else {
            enqueueSnackbar('Some files are missing', {
                variant: 'warning'
            });
        }
    };

    return (
        <div>
            <Paper>
                <List dense={true}  >
                    {data.map((data, index) => {
                        return (
                            <ListItemButton
                                key={data.id || index}
                                onClick={(e) => { setSource(data) }}
                                sx={{
                                    mx: 0.5,
                                    borderRadius: 1,
                                    position: 'relative',
                                    '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.06)',
                                    },
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        left: 16,
                                        right: 16,
                                        bottom: 0,
                                        height: '1px',
                                        backgroundColor: 'rgba(0, 0, 0, 0.22)',
                                    },
                                }}
                            >
                                <ListItem>
                                    <ListItemText
                                        primary={data.version}
                                        secondary={data.change_log ? data.change_log : null}
                                    />
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {data.asset_version_head === 'webgl_edit'  ?
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    px: 1.25,
                                                    py: 0.4,
                                                    borderRadius: 1,
                                                    color: 'success.dark',
                                                    backgroundColor: 'rgba(46, 125, 50, 0.10)',
                                                    border: '1px solid rgba(46, 125, 50, 0.22)',
                                                    fontWeight: 700,
                                                    lineHeight: 1.4,
                                                }}
                                            >
                                                EDITABLE
                                            </Typography> : null}
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                color: 'text.secondary',
                                            }}
                                        >
                                            {data.date_created ? moment(data.date_created).format("DD-MM-YYYY") : ""}
                                        </Typography>
                                    </Box>
                                </ListItem>
                            </ListItemButton>
                        )
                    })}
                </List>
            </Paper>

            <Dialog fullWidth={true} maxWidth="xl" open={webglDialog}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ m: 2 }}>
                        <WEBGLPlayer url={url} close={handleWebglDialog} assetData={assetData} />
                    </Box>
                </Box>
            </Dialog>
        </div>
    )
}

export default VersionLists